import {AbstractControl, AsyncValidatorFn, ValidationErrors} from '@angular/forms';
import {map} from 'rxjs/operators';
import {Observable} from 'rxjs';
import {AuthService} from '../../services/auth.service';

export function passwordComplexityValidator(authService: AuthService): AsyncValidatorFn {
  return (control: AbstractControl): Observable<ValidationErrors | null> => {
    const value = control.value;
    return authService.checkPasswordComplexity(value).pipe(
      map((passwordMessage: string) => {
        return passwordMessage ? { passwordComplexity: passwordMessage } : null;
      }),
    );
  };
}
